import ModuleController from "./ModuleController";
import Habit from "../models/habit";
import { apiResultSuccess, habitUpdateStreak } from "../apihelper";

export default class HabitController extends ModuleController {
    constructor(habit={}) {
        super();
        this.habit = habit;
        this.animate = false;
    }

    getHabit() {
        return this.habit;
    }

    setHabit(newHabit) {
        this.habit = newHabit;
    }

    // Creates new habit from editData
    // Runs reload on subject
    editHabit(editData={}) {
        this.habit = new Habit(editData);
        this.subject.runReload();
    }

    // Marks streak calling API habitUpdateStreak fn
    // Updates habit with new data using editHabit
    markStreak() {
        habitUpdateStreak(
            (results) => {
                if ( apiResultSuccess(results) ) {
                    if ( results.habit ) {
                        this.editHabit(results.habit);
                    } 
                } 
            }, this.habit.getId()
        )
    }
}